import React from 'react';

import { Group } from '@app/types/api/group';
import { Avatar } from '@chakra-snippets/avatar';

import AvatarListItem from './avatar-list-item';

interface GroupRowProps {
  option: Group;
  size?: 'xs' | 'sm' | 'md';
  boldName?: boolean;
  borderRadius?: string;
  showMemberCount?: boolean;
  rightElement?: React.ReactNode;
}

const GroupRow: React.FC<GroupRowProps> = ({
  option,
  size = 'md',
  boldName = false,
  borderRadius,
  showMemberCount = true,
  rightElement,
}) => {
  const memberCount = (option.members?.length || 0) + (option.leads?.length || 0);

  return (
    <AvatarListItem
      avatar={(
        <Avatar
          size={size}
          id={option.id}
          name={option.name}
          borderRadius={borderRadius || (size === 'md' ? 'md' : 'full')}
          bg="marleyRed.500"
          color="white"
        />
      )}
      name={option.name}
      subtitles={[showMemberCount ? `${memberCount} member${memberCount === 1 ? '' : 's'}` : 'Group']}
      showSubtitle
      size={size}
      boldName={boldName}
      rightElement={rightElement}
    />
  );
};

export default GroupRow;
